import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaiairporttopunecitycab() {



const cardData = {
  keyword: " Mumbai Airport to Pune City Cab ",

headingDescription: "Velocity Cab provides reliable and comfortable Mumbai Airport to Pune City cab services, ensuring a smooth and hassle-free journey for business trips, airport transfers, family outings, and leisure travel. Our professional drivers track flight arrivals, provide punctual pickups at Mumbai Airport, and ensure a seamless ride directly to Pune City. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Mumbai Airport to Pune City cab travel.",

topPlaces: [
  {
    title: "Dagdusheth Halwai Ganpati Temple",
    description: "Dagdusheth Halwai Ganpati Temple is one of Pune’s most revered spiritual landmarks dedicated to Lord Ganesha. Devotees and travelers can experience divine blessings, beautifully decorated idols, and a vibrant atmosphere, especially during major festivals like Ganesh Chaturthi."
  },
  {
    title: "Shaniwar Wada",
    description: "Shaniwar Wada is a historic fortification in Pune that once served as the seat of the Peshwas of the Maratha Empire. Visitors can explore its grand gateways, ruins, and enjoy the evening light and sound show that narrates Pune’s royal history."
  },
  {
    title: "Pune Okayama Friendship Garden",
    description: "Pune Okayama Friendship Garden is a serene Japanese-style garden featuring lush greenery, water streams, and beautifully designed walking paths. It is an ideal place for relaxation, photography, and peaceful nature walks."
  },
  {
    title: "Aga Khan Palace",
    description: "Aga Khan Palace is a historically significant monument linked to India’s freedom movement. It features elegant architecture, spacious gardens, and a museum dedicated to Mahatma Gandhi and important historical events."
  },
  {
    title: "Parvati Hill",
    description: "Parvati Hill is a popular heritage site in Pune offering panoramic city views from its hilltop temples. Visitors can climb the steps to explore ancient shrines and enjoy a peaceful, scenic environment."
  },
  {
    title: "Saras Baug",
    description: "Saras Baug is a well-known garden in Pune featuring lush green spaces and the famous Siddhivinayak Temple. It is a favorite spot for families, walkers, and visitors seeking relaxation in the city."
  },
  {
    title: "Bund Garden",
    description: "Bund Garden is a riverside park offering greenery, walking tracks, and boating facilities. It is a peaceful location for evening strolls and leisure activities in Pune."
  },
  {
    title: "Raja Dinkar Kelkar Museum",
    description: "Raja Dinkar Kelkar Museum showcases a rich collection of Indian artifacts, including sculptures, musical instruments, and cultural items that reflect India’s heritage and traditions."
  },
  {
    title: "Phoenix Marketcity Pune",
    description: "Phoenix Marketcity Pune is a popular shopping and entertainment hub featuring international brands, restaurants, cinemas, and entertainment zones, making it ideal for leisure and shopping experiences."
  },
  {
    title: "Pataleshwar Cave Temple",
    description: "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva, carved from a single basalt rock. It is known for its spiritual ambiance and historical significance in Pune."
  }
],



services: [
{
name: "Mumbai Airport to Kothrud Cab",
description: "Mumbai Airport to Kothrud cab service provides reliable transportation from Chhatrapati Shivaji Maharaj International Airport to Kothrud in Pune. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth travel via the Mumbai–Pune Expressway. Professional drivers monitor flight arrivals and provide timely pickup services from airport terminals. The service is ideal for corporate travelers, families, and tourists heading to Kothrud and nearby areas. Spacious vehicles allow convenient luggage storage while air-conditioned interiors ensure a relaxed long-distance journey. Flexible booking options make airport transfers simple and convenient."
},
{
name: "Mumbai Airport to Kondhwa Cab",
description: "Mumbai Airport to Kondhwa cab service offers dependable airport transportation from Mumbai Airport to Kondhwa in Pune. Well-maintained vehicles such as sedan, Ertiga, and Innova ensure comfortable highway travel. Professional drivers provide safe driving and punctual pickup services from airport terminals. Ideal for business travelers, tourists, and families traveling to the Kondhwa area. Spacious seating and luggage capacity ensure comfortable journeys for long-distance airport transfers. Advance booking options help passengers plan their trip conveniently."
},
{
name: "Mumbai Airport to Koregaon Park Cab",
description: "Mumbai Airport to Koregaon Park cab service provides reliable transportation between Mumbai Airport and the popular Koregaon Park area in Pune. Comfortable vehicles ensure smooth expressway travel with professional drivers handling the long-distance route safely. Pickup services are available directly from airport terminals with luggage assistance. Ideal for travelers heading to hotels, offices, or residences in Koregaon Park. Air-conditioned vehicles ensure relaxed travel even during long highway journeys."
},
{
name: "Mumbai Airport to Viman Nagar Cab",
description: "Mumbai Airport to Viman Nagar cab service offers convenient airport transfers between Mumbai Airport and Pune’s Viman Nagar area. Comfortable vehicles including sedan, Ertiga, and Innova provide safe expressway travel. Professional drivers provide punctual pickups from airport terminals and ensure smooth travel until the destination. Ideal for airport passengers heading to residential complexes, hotels, and offices in Viman Nagar."
},
{
name: "Mumbai Airport to Baner Taxi Fare",
description: "Mumbai Airport to Baner taxi fare service provides transparent pricing for passengers traveling between Mumbai Airport and Baner in Pune. Comfortable vehicles ensure smooth expressway journeys while experienced drivers provide safe driving and punctual pickup services from airport terminals. Travelers can choose from sedan, Ertiga, or Innova vehicles depending on comfort needs. Clear pricing details help passengers plan airport transfers easily."
},
{
name: "Mumbai Airport to Aundh Cab Fare",
description: "Mumbai Airport to Aundh cab fare service provides affordable pricing options for passengers traveling between Mumbai Airport and Aundh in Pune. Comfortable vehicles ensure smooth highway travel via the expressway while professional drivers provide safe driving and punctual airport pickups. Ideal for corporate travelers, families, and tourists heading to Pune."
},
{
name: "Mumbai Airport to Kharadi Taxi",
description: "Mumbai Airport to Kharadi taxi service provides reliable transportation between Mumbai Airport and Pune’s IT hub Kharadi. Comfortable vehicles ensure smooth expressway travel while professional drivers provide safe driving and timely pickups. Ideal for IT professionals, corporate travelers, and airport passengers heading to offices and hotels in Kharadi."
},
{
name: "Mumbai Airport to Wagholi Cab Service",
description: "Mumbai Airport to Wagholi cab service provides dependable airport transportation between Mumbai Airport and Wagholi in Pune. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth long-distance travel. Professional drivers ensure safe driving and punctual airport pickups with luggage assistance."
},
{
name: "Mumbai Airport to Magarpatta Cab Service",
description: "Mumbai Airport to Magarpatta cab service offers reliable airport transportation between Mumbai Airport and Magarpatta City in Pune. Comfortable vehicles ensure safe highway travel while professional drivers provide punctual pickups and smooth journeys to corporate offices and residential complexes in Magarpatta."
},
{
name: "Mumbai Airport Cab Service",
description: "Mumbai Airport cab service provides dependable airport transportation for pickups and drops across Mumbai and nearby cities such as Pune. Comfortable vehicles and experienced drivers ensure safe and timely airport travel. Ideal for business travelers, tourists, and families arriving at Mumbai Airport."
},
{
name: "Mumbai Airport Car Rental",
description: "Mumbai Airport car rental offers convenient vehicle hire services for passengers arriving at or departing from Mumbai Airport. Travelers can choose comfortable vehicles including sedan, Ertiga, and Innova for airport transfers or outstation trips."
},
{
name: "Mumbai Airport Transfer",
description: "Mumbai airport transfer service provides smooth transportation between Mumbai Airport and city destinations or nearby cities. Comfortable vehicles and experienced drivers ensure safe and timely airport travel."
},
{
name: "Airport Taxi Mumbai",
description: "Airport taxi Mumbai service provides reliable transportation for passengers traveling to or from Mumbai Airport terminals. Comfortable vehicles and professional drivers ensure smooth travel experiences."
},
{
name: "Mumbai Airport Taxi",
description: "Mumbai airport taxi service offers convenient transportation for airport arrivals and departures with comfortable vehicles and experienced drivers."
},
{
name: "Mumbai Airport Taxi Booking",
description: "Mumbai airport taxi booking allows passengers to easily reserve taxis for airport transfers. Flexible booking options ensure convenient ride scheduling."
},
{
name: "Car Hire Mumbai Airport",
description: "Car hire Mumbai Airport service provides vehicle rental with drivers for airport pickups and outstation travel. Comfortable vehicles ensure relaxed travel experiences."
},
{
name: "Mumbai to Shirdi Taxi Service",
description: "Mumbai to Shirdi taxi service provides reliable transportation for pilgrims traveling from Mumbai to Shirdi temple. Comfortable vehicles ensure safe and smooth highway journeys."
},
{
name: "Airport Cabs Mumbai",
description: "Airport cabs Mumbai provide dependable transportation services for passengers traveling to and from Mumbai Airport terminals."
},
{
name: "Cab from Pune to Mumbai Airport",
description: "Cab from Pune to Mumbai Airport provides reliable airport drop services between Pune and Mumbai Airport with comfortable vehicles."
},
{
name: "Mumbai Airport Taxi Service",
description: "Mumbai airport taxi service provides dependable transportation for airport pickups, drops, and outstation journeys."
},
{
name: "Taxi from Pune to Mumbai Airport",
description: "Taxi from Pune to Mumbai Airport service provides comfortable airport transfers between Pune city and Mumbai Airport."
},
{
name: "Prepaid Taxi Mumbai Airport",
description: "Prepaid taxi Mumbai Airport service provides convenient airport transportation with fixed pricing for passengers arriving at Mumbai Airport."
},
{
name: "Mumbai Airport to Kolhapur Cab Service",
description: "Mumbai Airport to Kolhapur cab service provides reliable long-distance transportation between Mumbai Airport and Kolhapur city with comfortable vehicles."
},
{
name: "Mumbai Airport to Pune Station Cab Service",
description: "Mumbai Airport to Pune Station cab service offers dependable transportation between Mumbai Airport and Pune railway station."
},
{
name: "Mumbai Airport to Pune Cab",
description: "Mumbai Airport to Pune cab service provides reliable airport transfer transportation between Mumbai Airport and Pune city with comfortable vehicles and professional drivers."
}
],

tableData: [
["Mumbai Airport to Kothrud Cab","Mumbai Airport to Kondhwa Cab"],
["Mumbai Airport to Koregaon Park Cab","Mumbai Airport to Viman Nagar Cab"],
["Mumbai Airport to Baner Taxi Fare","Mumbai Airport to Aundh Cab Fare"],
["Mumbai Airport to Kharadi Taxi","Mumbai Airport to Wagholi Cab Service"],
["Mumbai Airport to Magarpatta Cab Service","Mumbai Airport Cab Service"],
["Mumbai Airport Car Rental","Mumbai Airport Transfer"],
["Airport Taxi Mumbai","Mumbai Airport Taxi"],
["Mumbai Airport Taxi Booking","Car Hire Mumbai Airport"],
["Mumbai to Shirdi Taxi Service","Airport Cabs Mumbai"],
["Cab from Pune to Mumbai Airport","Mumbai Airport Taxi Service"],
["Taxi from Pune to Mumbai Airport","Prepaid Taxi Mumbai Airport"],
["Mumbai Airport to Kolhapur Cab Service","Mumbai Airport to Pune Station Cab Service"],
["Mumbai Airport to Pune Cab","Mumbai Airport Cab Service"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Airport Transfer Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who regularly handle Mumbai Airport to Pune City transfers. Their knowledge of airport terminals, pickup points, and expressway routes ensures smooth and timely travel."
  },
  {
    WhyChooseheading: "Transparent Airport Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Mumbai Airport to Pune City cab bookings. Customers receive clear fare details including toll charges and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Airport Pickup Service",
    WhyChoosedescription: "Our Mumbai Airport to Pune City cab service operates 24 hours a day. Whether your flight arrives early morning or late night, Velocity Cabs ensures reliable airport transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable long-distance airport transfer experience."
  },
  {
    WhyChooseheading: "Direct Airport to City Transfer",
    WhyChoosedescription: "Velocity Cabs provides direct cab services from Mumbai Airport to Pune City without unnecessary stops, ensuring faster and more convenient travel for passengers."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Pickup from All Mumbai Airport Terminals",
    WhyChoosedescription: "Our drivers provide pickup from all terminals of Mumbai Airport including Terminal 1 and Terminal 2, ensuring a hassle-free airport pickup experience."
  },
  {
    WhyChooseheading: "Trusted Airport Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Mumbai Airport to Pune City cab bookings thanks to punctual drivers, comfortable vehicles, and reliable airport transfer service."
  }
]
};

const faqData = [
  { question: "Do you provide cab service from Mumbai Airport to Pune City?", answer: "Yes, Velocity Cabs provides reliable cab services from Mumbai Airport to Pune City with professional drivers and comfortable vehicles." },
  { question: "Is Mumbai Airport to Pune City cab service available 24 hours?", answer: "Yes, our airport cab service operates 24/7 to match flight arrival schedules." },
  { question: "Which vehicles are available for Mumbai Airport to Pune City travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Mumbai Airport to Pune City?", answer: "Yes, we provide both one-way and round-trip cab services between Mumbai Airport and Pune City." },
  { question: "Do drivers wait if my flight is delayed?", answer: "Yes, our drivers track flight arrival times and coordinate with passengers for smooth pickup even if the flight is delayed." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Mumbai Airport to Pune City cab services online or through phone booking." },
  { question: "Do you provide drop service anywhere in Pune City?", answer: "Yes, Velocity Cabs provides doorstep drop services across Pune City including Baner, Hinjewadi, Wakad, Kharadi, Hadapsar, and Pimpri Chinchwad." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and holiday travel periods." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Karan Mehta",
    feedback:
      "Right after landing at Mumbai Airport, the ride to Pune felt completely stress-free. The cab was comfortable and the long journey went smoothly without any issues.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Joshi",
    feedback:
      "From airport pickup to reaching Pune, everything was handled very efficiently. The vehicle was clean, and the travel experience felt safe and well-organized.",
    rating: 5
  }
];

































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Airport to Pune City Cab Service | Velocity Cabs",
  "description": "Velocity Cabs provides reliable Mumbai Airport to Pune city cab service with professional drivers and affordable fares. Book one way and round trip taxis including Innova, Innova Crysta, Ertiga, and Sedan cabs for airport transfers, city-to-city travel, and corporate trips. Enjoy safe, comfortable, and punctual rides with easy online booking from Mumbai Airport to Pune city.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};



  return (
    <div>
    <Helmet>
  <title>Mumbai Airport to Pune City Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai Airport to Pune city cab with Velocity Cabs. Affordable one way & round trip taxis including Innova, Innova Crysta, Ertiga & Sedan for airport transfers, city-to-city travel & corporate trips." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>
  


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/41.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaiairporttopunecitycab;